export const zipsAPI = () => {
    return process.env.REACT_APP_ZIPS_API ?? "https://zips-2sefsba5fq-uc.a.run.app";
}